<template>
  <wa-page :is-showing-bandana="false" :is-showing-sitewide-modal="false">
    <template slot="header">
      <slot name="page-header">
        <wa-page-header-simple key="header" />
      </slot>
    </template>

    <template slot="content">
      <slot name="page-content">
        <main
          role="main"
          class="app-content padding-y-7xl"
        >
          <div class="container">
            <div class="laptop:margin-x-6xl">
              <div class="display-flex flex-column tablet:flex-row">
                <div :class="`purchase-${type} margin-auto margin-bottom-2xl tablet:margin-right-0 tablet:margin-bottom-0`">
                  <slot name="purchase-product" />

                  <div class="text-center">
                    <site-link :to="{ name: 'plans' }">See other Plans</site-link>
                  </div>
                </div>

                <div
                  class="purchase-form tablet:margin-right-4xl"
                  style="--hr-border-color: var(--white); --hr-border-width: var(--border-width-xs)"
                >
                  <slot name="purchase-flow" />
                </div>
              </div>

              <slot name="purchase-support" />
            </div>
          </div>
        </main>
      </slot>
    </template>

    <wa-page-footer-simple slot="footer" />
  </wa-page>
</template>

<script>
  export default {
    name: 'PagePurchase',

    props: {
      type: {
        type: String,
        default: 'plan'
      }
    }
  }
</script>
